import { Environment } from './environment.type';

export const environment: Environment = {
  brand: 'Bora Tasty Food',
  urlApi: 'https://api-test.itburgers.online/api',
  urlApiSignalR: 'https://api-test.itburgers.online/hubs/orders',
  production: false,
};
